import React, { useMemo } from "react";
import { AddNotes } from "../Forms/AddNotes";

function MemoizedAddNotes({
  isNotes,
  recruitment,
  notesCloseHandler,
  onNoteSubmitHandler,
}) {
  return useMemo(() => {
    return (
      <AddNotes
        open={isNotes}
        handleClose={notesCloseHandler}
        data={recruitment}
        onSubmitHandler={onNoteSubmitHandler}
      />
    );
  }, [isNotes, recruitment, notesCloseHandler, onNoteSubmitHandler]);
}

export default MemoizedAddNotes;
